
// Function to close all mega menus
function closeAllMegaMenus() {
  document.querySelectorAll('details.mega-menu').forEach(detail => {
    detail.removeAttribute('open');
    const summary = detail.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
    }
    // Reset animation by removing and re-adding the animation class
    const links = detail.querySelectorAll('.mega-menu__link');
    links.forEach(link => {
      link.style.animation = 'none';
      link.offsetHeight; // Trigger reflow
      link.style.animation = null;
    });
  });
}

// Add event listeners to all menu items
document.querySelectorAll('.header__menu-item').forEach(menuItem => {
  menuItem.addEventListener('mouseenter', () => {
    // Close all mega menus when hovering over any menu item
    closeAllMegaMenus();
  });
});

// Handle header-menu elements (mega menus and regular dropdowns)
document.querySelectorAll('header-menu').forEach(headerMenu => {
  const firstDetail = headerMenu.querySelector('details');
  const summary = firstDetail.querySelector('summary');
  const submenu = firstDetail.querySelector('ul');

  if (firstDetail.classList.contains('mega-menu')) {
    const contentDiv = firstDetail.querySelector('div'); 
    summary.addEventListener('mouseenter', () => {
      closeAllMegaMenus();
      firstDetail.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
      
      // Force restart animation after a small delay
      setTimeout(() => {
        const links = firstDetail.querySelectorAll('.mega-menu__link');
        links.forEach((link, index) => {
          link.style.animation = 'none';
          link.offsetHeight; // Trigger reflow
          link.style.animation = 'fadeInUp 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards';
          link.style.animationDelay = (index * 0.05) + 's';
        });
      }, 10);
    });
    contentDiv.addEventListener('mouseleave', () => {
      firstDetail.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    });
    return
  }

  // For regular menu items (non-mega menu), close all mega menus on hover
  summary.addEventListener('mouseenter', () => {
    closeAllMegaMenus();
    firstDetail.setAttribute('open', '');
    summary.setAttribute('aria-expanded', 'true');
  });
  
  firstDetail.addEventListener('mouseleave', () => {
    firstDetail.removeAttribute('open');
    summary.setAttribute('aria-expanded', 'false');
    if (submenu) {
      submenu.querySelectorAll('details').forEach(nestedDetail => {
        nestedDetail.removeAttribute('open');
      });
    }
  })
  
  if (submenu) {
    submenu.querySelectorAll('details').forEach(nestedDetail => {
      const nestedSummary = nestedDetail.querySelector('summary');
      nestedSummary.addEventListener('mouseenter', () => {
        nestedDetail.setAttribute('open', '');
        nestedSummary.setAttribute('aria-expanded', 'true');
      });
    });
  }
});
